import React from 'react'
import { browserHistory } from 'react-router'
import { Card, CardHeader, CardText } from 'material-ui/Card'
import { RaisedButton } from 'material-ui'
import {
  Table,
  TableBody,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import api from '../../../api'
import Create from '../../crud/create'
import ResourceDisplay from '../../resource-display'
import { formatDateTime } from '../../../formatters'
import fields from './user-membership-fields'

class UserMembership extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false
    }
  }

  componentWillMount () {
    this.loadUserMembership()
      .then(() => {
        this.setState({ isLoaded: true })
      })
  }

  loadUserMembership () {
    const { userId } = this.props
    const filters = {
      member_id: userId,
      member_type: 'user'
    }

    return api.get('admin/memberships', { body: { filters } })
      .then(res => res.json())
      .then(([membership]) => {
        this.setState({ membership })
        return membership
      })
  }

  handleResourceCreated () {
    this.loadUserMembership()
  }

  render () {
    const { userId } = this.props
    const { isLoaded, membership } = this.state

    if (!isLoaded) return null

    if (!membership) {
      return (
        <Create
// @ts-ignore
          title='Add Individual Membership'
          fields={fields}
          apiPath='admin/memberships'
          successRedirectPath={`/security/users/${userId}/edit`}
          cancelRedirectPath={`/security/users/${userId}/edit`}
          onResourceCreated={() => this.handleResourceCreated()}
          buildMenuItems={() => ([])}
          resource={{
            member_id: userId,
            member_type: 'user'
          }}
        />
      )
    }

    return (
      <Card>
        <CardHeader title='Individual Membership' />
        <CardText>
          <Table selectable={false}>
            <TableBody displayRowCheckbox={false}>
              <TableRow>
                <TableRowColumn>
                  Membership Plan
                </TableRowColumn>
                <TableRowColumn>
                  <ResourceDisplay
                    path='admin/membership_plans'
                    filters={{ id: membership.membership_plan_id }}
                    display='name'
                    link={res => `/membership/membership-plans/${res.id}/edit`}
                  />
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  Expiry
                </TableRowColumn>
                <TableRowColumn>
                  {formatDateTime(membership.expires_at)}
                </TableRowColumn>
              </TableRow>
              <TableRow>
                <TableRowColumn>
                  <RaisedButton
                    label='Edit'
                    primary
                    onClick={() => browserHistory.push(
                      `/membership/user-memberships/${membership.id}/edit`
                    )}
                  />
                </TableRowColumn>
              </TableRow>
            </TableBody>
          </Table>
        </CardText>
      </Card>
    )
  }
}

export default UserMembership
